import { createFileRoute, Link, redirect } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { auth } from '@/lib/firebase'

export const Route = createFileRoute('/')({
  component: App,
  beforeLoad: async () => {
    if (auth.currentUser) {
      throw redirect({ to: '/documents' })
    } else {
      throw redirect({ to: '/login' })
    }
  },
})

function App() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4">
      <h1>LineWise</h1>
      <p>Please login to continue</p>
      <Button asChild>
        <Link to="/login">Login</Link>
      </Button>
    </div>
  )
}
